import Typing from "react-animated-typewriter";
import Profile from "./Profile";
import Profile2 from "./Profile2";
function AnimatedTyping() {
  const wait = 1500;
  return (
    <>
      <div className="home">
        <div className="transparent">
          <h1>
            <Typing
              steps={[
                "Hi I'm Apurva Prakash",
                wait,
                "I'm a web developer",
                wait
              ]}
              loop={Infinity}
              wrapper="b"
              typeDelay={100}
              deleteDelay={10}
            />{" "}
          </h1>
          <p className="transP">
            Seeking an entry-level position to begin my career in a high-level
            professional environment. To secure employment with a reputable
            company, where I can utilize my skills and business studies
            background to the maximum.{" "}
          </p>
        </div>
      </div>
      <Profile2 />
      <Profile />
    </>
  );
}
export default AnimatedTyping;
